<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Tienda a Pedir</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Fecha Ultima Edición</th>
          <th class="text-center">Estado</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda_origen.nombre }}</td>
          <td>{{ current.tienda_destino.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
          <td>{{ current.tipo_traslado_str }}</td>
          <td class="text-center"></td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent
      :currentPage="currentPage"
      :data="dataTabla"
      @pagechanged="onPageChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "salidastraslados/salidas_traslado",
    }),
  },
  mounted() {
    this.$store.dispatch("salidastraslados/fetch");
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-salida_traslado-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-salida_traslado-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("salidastraslados/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
